import { appState, dispatchStateEvent } from '../../store/appState.js';

let availableCurrencies = []; // Chứa danh sách mảng các mã tiền tệ

export function initCurrencyPickerModal() {
    const currencyPickerModal = document.getElementById('currency-picker-modal');
    const currencySearchInput = document.getElementById('currency-search-input');
    const currencyList = document.getElementById('currency-list');
    const btnSelectCurrency = document.getElementById('btn-select-currency');
    const displayNewCurrency = document.getElementById('display-new-currency');

    if(!currencyPickerModal) return;

    function renderCurrencyList(searchTerm = '') {
        currencyList.innerHTML = '';
        
        // Lọc tìm kiếm theo từ khóa (Không phân biệt hoa thường)
        const filtered = availableCurrencies.filter(c => c.toLowerCase().includes(searchTerm.toLowerCase()));
        
        if (filtered.length === 0) {
            currencyList.innerHTML = '<p class="text-center text-gray-500 text-sm mt-4">No currency found.</p>';
            return;
        }
        
        filtered.forEach(currency => {
            const btn = document.createElement('button');
            btn.className = 'w-full text-left p-3 hover:bg-gray-800 transition border-b border-gray-800 flex justify-between items-center';
            
            // Kiểm tra xem nút này có đang được chọn không để tô xanh
            const isSelected = displayNewCurrency.getAttribute('data-currency') === currency;
            if (isSelected) {
                btn.classList.add('text-primary', 'font-bold');
                btn.innerHTML = `<span>${currency}</span> <i class="fa-solid fa-check"></i>`;
            } else {
                btn.classList.add('text-gray-300');
                btn.innerHTML = `<span>${currency}</span>`;
            }
            
            // Bấm chọn tiền tệ -> Đóng Modal, Gán lên Form
            btn.onclick = () => {
                displayNewCurrency.innerText = currency;
                displayNewCurrency.setAttribute('data-currency', currency);
                currencyPickerModal.classList.add('hidden');
                currencyPickerModal.classList.remove('flex');
            };
            currencyList.appendChild(btn);
        });
    }

    // Mở Modal
    btnSelectCurrency.addEventListener('click', () => {
        // Trích xuất toàn bộ Key từ Cache Tỉ giá (Object.keys)
        availableCurrencies = Object.keys(appState.exchangeRatesCache);
        if (availableCurrencies.length === 0) availableCurrencies = ['VND', 'USD', 'EUR', 'JPY', 'GBP', 'AUD', 'CAD']; // Backup nếu API sập
        
        // Sắp xếp Alphabet, nhưng đưa VND lên đầu tiên
        availableCurrencies.sort((a, b) => a === 'VND' ? -1 : b === 'VND' ? 1 : a.localeCompare(b));
        
        currencySearchInput.value = ''; // Xóa trắng ô tìm kiếm
        renderCurrencyList('');
        
        currencyPickerModal.classList.remove('hidden');
        currencyPickerModal.classList.add('flex');
    });

    // Gõ tìm kiếm realtime
    currencySearchInput.addEventListener('input', (e) => {
        renderCurrencyList(e.target.value);
    });

    // Nút Đóng
    document.getElementById('btn-close-currency-picker').addEventListener('click', () => {
        currencyPickerModal.classList.add('hidden');
        currencyPickerModal.classList.remove('flex');
    });
}
